export default __webpack_public_path__ + "assets/37aa99c3087f7f195014a09985302fda.svg";